var map = {
	"./1.jpg": 55183,
	"./1000px-IBM_logo.svg.png": 72322,
	"./131px-Moody’s_logo.svg.png": 52842,
	"./2.jpeg": 37897,
	"./3.jpg": 92701,
	"./368px-Google_2015_logo.svg.png": 17980,
	"./4.jpg": 37942,
	"./800px-Microsoft_Azure_Logo.svg.png": 14179,
	"./Amazondotcom.png": 65788,
	"./FactSet-Web.png": 62449,
	"./Microsoft-Logo.png": 41736,
	"./Nvidia_logo.png": 69399,
	"./Pytorch_logo.png": 17281,
	"./QuSandbox logo Draft 3.png": 10950,
	"./RStudio-Logo.png": 74684,
	"./Rlogo.png": 51285,
	"./Snowflake.svg": 48678,
	"./apple-icon.png": 87658,
	"./bg-pricing.jpeg": 62309,
	"./card-1.jpeg": 55329,
	"./card-2.jpeg": 83680,
	"./card-3.jpeg": 74743,
	"./claude.png": 2470,
	"./clint-mckoy.jpg": 82818,
	"./create_cards/ask.png": 57922,
	"./create_cards/benchmark.png": 35044,
	"./create_cards/blog.png": 601,
	"./create_cards/case-study.png": 6649,
	"./create_cards/course.png": 64274,
	"./create_cards/datagen.png": 90543,
	"./create_cards/e-book.png": 42360,
	"./create_cards/form_design.png": 50878,
	"./create_cards/handout.png": 12676,
	"./create_cards/insights.png": 98866,
	"./create_cards/labs.png": 27717,
	"./create_cards/lecture.png": 95303,
	"./create_cards/model_development.png": 51212,
	"./create_cards/model_validation.png": 77910,
	"./create_cards/module.png": 81493,
	"./create_cards/newsletter.png": 28080,
	"./create_cards/podcast.png": 91901,
	"./create_cards/project-plan.png": 66092,
	"./create_cards/qcreate.png": 10852,
	"./create_cards/report.png": 73639,
	"./create_cards/research.png": 92594,
	"./create_cards/session.png": 93261,
	"./create_cards/summarize.png": 88190,
	"./create_cards/video.png": 91764,
	"./create_cards/whitepaper.png": 83038,
	"./create_cards_16_9/ask.png": 91678,
	"./create_cards_16_9/benchmark.png": 87128,
	"./create_cards_16_9/blog.png": 27077,
	"./create_cards_16_9/case-study.png": 51493,
	"./create_cards_16_9/course.png": 78334,
	"./create_cards_16_9/e-book.png": 18828,
	"./create_cards_16_9/form_design.png": 4138,
	"./create_cards_16_9/handout.png": 96488,
	"./create_cards_16_9/insights.png": 59806,
	"./create_cards_16_9/labs.png": 98289,
	"./create_cards_16_9/lecture.png": 39467,
	"./create_cards_16_9/model_development.png": 67976,
	"./create_cards_16_9/model_validation.png": 37322,
	"./create_cards_16_9/newsletter.png": 29588,
	"./create_cards_16_9/podcast.png": 34161,
	"./create_cards_16_9/project-plan.png": 44240,
	"./create_cards_16_9/projects.png": 48955,
	"./create_cards_16_9/qcreate.png": 57912,
	"./create_cards_16_9/report.png": 26563,
	"./create_cards_16_9/research.png": 23366,
	"./create_cards_16_9/summarize.png": 1642,
	"./create_cards_16_9/video.png": 48656,
	"./create_cards_16_9/whitepaper.png": 45410,
	"./default-avatar.png": 51915,
	"./faces/Sri-headshot.png": 28514,
	"./faces/avatar.jpg": 55162,
	"./faces/card-profile1-square.jpg": 8440,
	"./faces/card-profile2-square.jpg": 25913,
	"./faces/generic-user-icon-19.jpg": 10865,
	"./faces/marc.jpg": 11322,
	"./favicon.png": 90286,
	"./flags/AD.png": 3591,
	"./flags/AE.png": 1630,
	"./flags/AG.png": 83532,
	"./flags/AM.png": 14358,
	"./flags/AR.png": 481,
	"./flags/AT.png": 7383,
	"./flags/AU.png": 64366,
	"./flags/BE.png": 57215,
	"./flags/BF.png": 71940,
	"./flags/BG.png": 35181,
	"./flags/BO.png": 34357,
	"./flags/BR.png": 3376,
	"./flags/CA.png": 29204,
	"./flags/CD.png": 71545,
	"./flags/CG.png": 57538,
	"./flags/CH.png": 58405,
	"./flags/CL.png": 22721,
	"./flags/CM.png": 50008,
	"./flags/CN.png": 24499,
	"./flags/CO.png": 73738,
	"./flags/CZ.png": 25831,
	"./flags/DE.png": 26873,
	"./flags/DJ.png": 11310,
	"./flags/DK.png": 40535,
	"./flags/DZ.png": 13822,
	"./flags/EE.png": 14866,
	"./flags/EG.png": 38848,
	"./flags/ES.png": 86452,
	"./flags/FI.png": 35759,
	"./flags/FR.png": 35948,
	"./flags/GA.png": 5472,
	"./flags/GB.png": 60507,
	"./flags/GM.png": 80620,
	"./flags/GT.png": 22621,
	"./flags/HN.png": 29966,
	"./flags/HT.png": 14692,
	"./flags/HU.png": 77933,
	"./flags/ID.png": 50687,
	"./flags/IE.png": 53750,
	"./flags/IL.png": 455,
	"./flags/IN.png": 50069,
	"./flags/IQ.png": 28610,
	"./flags/IR.png": 95193,
	"./flags/IT.png": 74319,
	"./flags/JM.png": 13519,
	"./flags/JO.png": 55709,
	"./flags/JP.png": 22298,
	"./flags/KG.png": 72634,
	"./flags/KN.png": 17083,
	"./flags/KP.png": 96325,
	"./flags/KR.png": 67543,
	"./flags/KW.png": 11658,
	"./flags/KZ.png": 89583,
	"./flags/LA.png": 37493,
	"./flags/LB.png": 51742,
	"./flags/LC.png": 39431,
	"./flags/LS.png": 78455,
	"./flags/LU.png": 66945,
	"./flags/LV.png": 36362,
	"./flags/MG.png": 81880,
	"./flags/MK.png": 32340,
	"./flags/ML.png": 98603,
	"./flags/MM.png": 61122,
	"./flags/MT.png": 53539,
	"./flags/MX.png": 6879,
	"./flags/NA.png": 26735,
	"./flags/NE.png": 71531,
	"./flags/NG.png": 47609,
	"./flags/NI.png": 74071,
	"./flags/NL.png": 15626,
	"./flags/NO.png": 73057,
	"./flags/OM.png": 7188,
	"./flags/PA.png": 64433,
	"./flags/PE.png": 14069,
	"./flags/PG.png": 16007,
	"./flags/PK.png": 27419,
	"./flags/PL.png": 17476,
	"./flags/PT.png": 96924,
	"./flags/PY.png": 41369,
	"./flags/QA.png": 65354,
	"./flags/RO.png": 62629,
	"./flags/RU.png": 79679,
	"./flags/RW.png": 96717,
	"./flags/SA.png": 75364,
	"./flags/SE.png": 78688,
	"./flags/SG.png": 42802,
	"./flags/SL.png": 61969,
	"./flags/SN.png": 33027,
	"./flags/SO.png": 31802,
	"./flags/SV.png": 29675,
	"./flags/TD.png": 1952,
	"./flags/TJ.png": 34206,
	"./flags/TL.png": 7080,
	"./flags/TR.png": 79014,
	"./flags/TZ.png": 8398,
	"./flags/UA.png": 31430,
	"./flags/US.png": 52484,
	"./flags/VE.png": 48707,
	"./flags/VN.png": 5760,
	"./flags/YE.png": 6406,
	"./gemini.png": 57793,
	"./generic-user-icon-19.jpg": 29740,
	"./header-doc.jpeg": 33795,
	"./homescreen.jpeg": 90762,
	"./icons/anthropic.png": 88053,
	"./icons/claude.png": 28563,
	"./icons/cohere.png": 17749,
	"./icons/deepseek.png": 60755,
	"./icons/gemini.png": 12264,
	"./icons/grok.png": 32456,
	"./icons/mistral.png": 79985,
	"./icons/ollama.png": 12695,
	"./icons/openai.png": 57459,
	"./icons/openrouter.png": 89258,
	"./image_placeholder.jpg": 43847,
	"./julia.png": 10949,
	"./julia.svg": 32521,
	"./jupyter.jpg": 99377,
	"./lock.jpeg": 8698,
	"./login.jpeg": 54146,
	"./logo-white.svg": 64415,
	"./logo.svg": 67503,
	"./mask.png": 90264,
	"./mathworks_logo.png": 89322,
	"./new_logo.png": 76132,
	"./openai.png": 91914,
	"./osman-rana-G7VN8NadjO0-unsplash.jpg": 46737,
	"./placeholder.jpg": 76357,
	"./product1.jpg": 92450,
	"./product2.jpg": 54733,
	"./product3.jpg": 86160,
	"./pytorch-logo.png": 95151,
	"./qcreate.png": 66787,
	"./qcreate_logo.png": 87933,
	"./qucoursify_logo.png": 72118,
	"./qucreate_logo.png": 60114,
	"./qusandbox_logo_draft_3__1_ (1).png": 46669,
	"./qusandbox_logo_draft_3__1_.png": 1023,
	"./qusandbox_logo_v2.5.png": 67111,
	"./register.jpeg": 70092,
	"./s&p_global.png": 69917,
	"./sidebar-1.jpg": 52688,
	"./sidebar-2.jpg": 37023,
	"./sidebar-3.jpg": 24354,
	"./sidebar-4.jpg": 29937,
	"./templates/Checklist.png": 70134,
	"./templates/Description.png": 47608,
	"./templates/Design.png": 7862,
	"./templates/Functionality.png": 4979,
	"./templates/Inventory.png": 33262,
	"./templates/Model.png": 88613,
	"./templates/Planning.png": 72911,
	"./templates/Reporting.png": 81148,
	"./templates/Risk.png": 14805,
	"./templates/Tracking.png": 8743,
	"./templates/Validation.png": 9749,
	"./tensorflow.png": 75127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;